import { first_present } from "./organization_profile_setup_api";

const ADDRESS_FIELDS = [
  "street_address",
  "suburb",
  "town",
  "province",
  "postal_code",
  "country",
];

function get_empty_address() {
  return Object.fromEntries(ADDRESS_FIELDS.map((field) => [field, ""]));
}

function get_location_parts(location) {
  return String(location || "")
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
}

function set_storage_items(items) {
  items.forEach(([key, value]) => {
    localStorage.setItem(key, value || "");
  });
}

export default {
  get_empty_company_address() {
    return get_empty_address();
  },
 get_address_from_location(location) {
  const parts = get_location_parts(location);

  return Object.fromEntries(
    ADDRESS_FIELDS.map((field, index) => [
      field,
      Reflect.get(parts, index) ?? "",
    ])
  );
},


  get_company_address_values(company = {}) {
    const address = company.address || {};
    const location_address = this.get_address_from_location(company.location);

    return ({
      street_address: first_present([company.street_address, address.street_address, location_address.street_address]),
      suburb: first_present([company.suburb, company.local_area, address.suburb, location_address.suburb]),
      town: first_present([company.town, company.city, address.town, address.city, location_address.town]),
      province: first_present([company.province, address.province, location_address.province]),
      postal_code: first_present([company.postal_code, company.code, address.postal_code, location_address.postal_code]),
      country: first_present([company.country, address.country, location_address.country]),
    });
  },
  get_address_component(place, type) {
    return place.address_components?.find((component) => component.types.includes(type))?.long_name || "";
  },
  get_first_address_value(...values) {
    return values.find(Boolean) || "";
  },
  set_company_address_from_place(place) {
    const street_number = this.get_address_component(place, "street_number");
    const route = this.get_address_component(place, "route");

    this.address_list.street_address = this.get_first_address_value(
      [street_number, route].filter(Boolean).join(" "),
      place.formatted_address,
      this.address_list.street_address
    );
    this.address_list.suburb = this.get_first_address_value(
      this.get_address_component(place, "sublocality"),
      this.get_address_component(place, "sublocality_level_1"),
      this.get_address_component(place, "neighborhood")
    );
    this.address_list.town = this.get_first_address_value(
      this.get_address_component(place, "locality"),
      this.get_address_component(place, "administrative_area_level_2")
    );
    this.address_list.province = this.get_address_component(place, "administrative_area_level_1");
    this.address_list.postal_code = this.get_address_component(place, "postal_code");
    this.address_list.country = this.get_address_component(place, "country");
    this.latitude = place.geometry?.location?.lat?.() ?? null;
    this.longitude = place.geometry?.location?.lng?.() ?? null;
    this.form.location = this.get_first_address_value(place.formatted_address, this.get_location_value());
  },
  get_address_parts() {
    return [
      this.address_list.street_address,
      this.address_list.suburb,
      this.address_list.town,
      this.address_list.province,
      this.address_list.postal_code,
    ].map((part) => String(part || "").trim()).filter(Boolean);
  },
  get_location_value() {
    return this.get_address_parts().join(", ") || this.form.location || "";
  },
  sync_location_from_address() {
    this.form.location = this.get_location_value();
  },
  get_profile_details_payload() {
    return ({
      base_profile_id: this.get_base_profile_id(),
      organization_name: this.form.organization_name,
      type_of_organization_id: this.get_type_of_organization_id(),
      description: this.form.description,
      email: this.form.email,
      tell_number: this.form.tell_number,
      location: this.get_location_value(),
      street_address: this.address_list.street_address,
      suburb: this.address_list.suburb,
      town: this.address_list.town,
      province: this.address_list.province,
      postal_code: this.address_list.postal_code,
      country: this.address_list.country,
      latitude: this.latitude,
      longitude: this.longitude,
      primary_color: this.form.primary_color,
      secondary_color: this.form.secondary_color,
      tertiary_color: this.form.tertiary_color,
    });
  },
  get_saved_company_details() {
    return ({
      ...(this.company || {}),
      company_name: this.form.organization_name,
      description: this.form.description,
      email: this.form.email,
      tell_number: this.form.tell_number,
      location: this.get_location_value(),
      street_address: this.address_list.street_address,
      suburb: this.address_list.suburb,
      town: this.address_list.town,
      province: this.address_list.province,
      postal_code: this.address_list.postal_code,
      country: this.address_list.country,
      latitude: this.latitude,
      longitude: this.longitude,
      primary_color: this.form.primary_color,
      secondary_color: this.form.secondary_color,
      tertiary_color: this.form.tertiary_color,
    });
  },
  sync_saved_profile_details() {
    this.company = this.get_saved_company_details();
    this.user_details = {
      ...(this.user_details || {}),
      organization_name: this.form.organization_name,
      company_name: this.form.organization_name,
      organization_description: this.form.description,
      organization_email: this.form.email,
      organization_tell_number: this.form.tell_number,
      organization_location: this.get_location_value(),
      organization_primary_color: this.form.primary_color,
      organization_secondary_color: this.form.secondary_color,
      organization_tertiary_color: this.form.tertiary_color,
    };

    set_storage_items([
      ["organization_name", this.form.organization_name],
      ["company_name", this.form.organization_name],
      ["organization_description", this.form.description],
      ["organization_email", this.form.email],
      ["organization_tell_number", this.form.tell_number],
      ["organization_location", this.get_location_value()],
      ["organization_primary_color", this.form.primary_color],
      ["organization_secondary_color", this.form.secondary_color],
      ["organization_tertiary_color", this.form.tertiary_color],
    ]);
  },
};
